export default "__VITE_ASSET__2021b806__"